var _title, _path, _polyline;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "refresh")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.78,21.34A13.78,13.78,0,1,1,20,7.56a13.56,13.56,0,0,1,2.72.27",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "18.47 2.98 23.28 7.79 18.47 12.6",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}

export default SvgRefresh;